import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        type_name: "",
        p_type: "",
        type_icon: "",
        param_keys: [],
        status: null
      },
      imgList: [],
      rules: {
        type_name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        o_type: [{
          required: true,
          message: "请输入登录类型",
          trigger: "blur"
        }],
        type_icon: [{
          required: true,
          message: "请上传图标",
          trigger: "blur"
        }],
        param_keys: [{
          required: true,
          message: "请添加参数",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "请输入参数",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  datas.param_keys = data.param_keys ? data.param_keys.map(function (item) {
                    return {
                      value: item
                    };
                  }) : [];
                  _this.formData = _objectSpread({}, datas);
                  _this.imgList = [datas.type_icon];
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e) {
      this.imgList = e;
      this.formData.type_icon = e[0] && e[0].response ? e[0].response.data : '';
    },
    addContent: function addContent() {
      this.formData.param_keys.push({
        value: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.param_keys.indexOf(item);

      if (index !== -1) {
        this.formData.param_keys.splice(index, 1);
      }
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.imgList = isClear ? [] : this.formDataMake.type_icon ? [this.formDataMake.type_icon] : [];
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, size, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 13;
                    break;
                  }

                  data = JSON.parse(JSON.stringify(_this2.formData));
                  data.param_keys = data.param_keys.map(function (item) {
                    return item.value;
                  });
                  size = new Set(data.param_keys).size;

                  if (!(data.param_keys.length !== size)) {
                    _context2.next = 7;
                    break;
                  }

                  _this2.$message.error('参数不能输入相同的值');

                  return _context2.abrupt("return");

                case 7:
                  if (!_this2.formData.id) {
                    _context2.next = 10;
                    break;
                  }

                  _context2.next = 10;
                  return _this2.secondConfirmation();

                case 10:
                  data.type_icon = _this2.$utils.Fullpath(data.type_icon);
                  reqFn = data.id ? 'appLoginTypeUpdate' : 'appLoginTypeAdd';

                  _this2.$api[reqFn](data).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};